export const email = "soporte@alliance-cloud.com";
export const phone = {
  number: "+584127873235",
  mask: "(+58) 0412-7873235"
};


export const phone_pa = {
  number: "+50769725939",
  mask: "(+507) 6972-5939"
};
